import { render, staticRenderFns } from "./WithActions.vue?vue&type=template&id=71c52f41&lang=pug"
import script from "./WithActions.vue?vue&type=script&lang=js"
export * from "./WithActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports